export default {
  getHead: () => {
    return [{name: '사업장명'}, {name: '공종'}, {name: '발생일'}, {name: '발생장소'}, {name: '대상자'}, {name: '재해형태'}, {name: '개선전 위험성'}, {name: '작성소속'}, {name: '작성자 '}, {name: '작성일'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).inputA_1
      case 1: return func.getContent(value).inputB_2
      case 2: return func.getContent(value).inputB_3
      case 3: return func.getContent(value).inputB_4
      case 4: return func.getContent(value).inputB_5
      case 5: return func.getContent(value).inputB_8
      case 6: return func.getContent(value).frequency *  func.getContent(value).strength
      case 7: return func.getContent(value).inputA_3
      case 8: return func.getContent(value).stdInfo.writer_name
      case 9: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.inputB_3) {
      nav.dateTarget = 'content$body.inputB_3'
      nav.dateBegin = 'nav.value.inputB_3.sDate'
      nav.dateEnd = 'nav.value.inputB_3.eDate'
    }
    return {inputB_3: nav.value.inputB_3, inputB_2: nav.value.inputB_2, inputB_8: nav.value.inputB_8}
  },
  getSearchKeyword: (nav) => {
    return [
      'content$body.inputB_2*[:nav.page.p62.inputB_2]',
      'content$body.inputB_8*[:nav.page.p62.inputB_8]'
    ]
  },
}
